<template>
  <div>
    <div v-for="rateYearChanges in parsedDetails.ChangesByRateYear">
      <h1>Year {{ getRateYearName(rateYearChanges.RateYearId) }}</h1>
      <div class="mb-4" v-if="rateYearChanges.Added.length > 0">
        <h3>Rates Added</h3>
        <ul>
          <li v-for="rateValue in rateYearChanges.Added">
            <rate-value-detail-row :existing-rate-value="rateValue"/>
          </li>
        </ul>
      </div>
      <div class="mb-4" v-if="rateYearChanges.Deleted.length > 0">
        <h3>Rates Removed</h3>
        <ul>
          <li v-for="rateValue in rateYearChanges.Deleted">
            <rate-value-detail-row :existing-rate-value="rateValue"/>
          </li>
        </ul>
      </div>
      <div class="mb-4" v-if="rateYearChanges.Updated.length > 0">
        <h3>Rates Updated</h3>
        <ul>
          <li v-for="updatePairs in rateYearChanges.Updated">
            <rate-value-detail-row :existing-rate-value="updatePairs.Old" :updated-rate-value="updatePairs.New"/>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import RateValueDetailRow from "./RateValueDetailRow.vue";

export default {
   props: {
     jsonString: { type: String, required: true}
   },
   data() {
     return {
       parsedDetails: null,
       rateYear: null,
     }
   },
   computed: {
     ...amfx.map('cobraPlans','getPlan'),
     ...amfx.map('cobraRates',  'ratePeriods'),
     cobraPlan() {
       return this.getPlan(this.parsedDetails.PlanId);
     },
   },
   async created() {
     this.parsedDetails = JSON.parse(this.jsonString);
     await this.$store.dispatch('cobraRates/load', { employerId: this.employerId, planId:this.parsedDetails.PlanId });
   },
  methods: {
    getRateYearName(yearId) {
      return this.ratePeriods.find(rp => rp.id === yearId).name;
    }
  },
   components: {
     RateValueDetailRow,
   }
 }
</script>

<style scoped lang="scss">
  h1 {
    font-size: 1em;
  }
  h3 {
    margin-left: 1.2em;
    font-size: 1em;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0 2em 0 2em;
  }
  ul label + span {
    float: right;
  }
  li {
    padding: 4px 8px;
    overflow: auto;
  }
  li:nth-of-type(odd) {
    background-color: #f0f0f0;
  }
</style>



// WEBPACK FOOTER //
// src/history/modals/CobraRateChangeDetails.vue